@if (event) {
  @if (isArchived) {
    <!-- class lives on a wrapper: Angular hydration re-applies static classes on SSR'd wb-* hosts and wipes Stencil's `hydrated` -->
    <div class="archived-tag">
      <wb-tag variant="tertiary" theme="light">{{ 'ARCHIVED_CONTENT' | translate }}</wb-tag>
    </div>
  }
  @if (event.urlSlug) {
    @if (isExternalUrl()) {
      <a [href]="this.event.urlSlug" class="link-wrapper">
        <ng-container *ngTemplateOutlet="tpl"></ng-container>
      </a>
    }
    @if (!isExternalUrl()) {
      <a [routerLink]="[this.event.urlSlug]" class="link-wrapper">
        <ng-container *ngTemplateOutlet="tpl"></ng-container>
      </a>
    }
  } @else {
    @if (event.image) {
      <mb-media [media]="event.image"></mb-media>
    }
    @if (event.state === eventStates.UPCOMING) {
      <header>
        <mb-small-spinner></mb-small-spinner>
        @if (distance) {
          <span>
            {{ 'EVENT_CARD_STARTS_IN' | translate: { distance: distance } }}
          </span>
        }
      </header>
    }
    @if (event.state === eventStates.RUNNING) {
      <header>
        <mb-live-indicator></mb-live-indicator>
        {{ 'EVENT_CARD_RUNNING' | translate }}
      </header>
    }
    @if (event.attendanceStatus) {
      <span
        class="event-card-icon mb-icon mb-icon-event-{{ attendanceIcons[event.attendanceStatus] }}"
        [class.below-archived-tag]="isArchived"
      >
      </span>
    }
    <section>
      @if (event.titleHash) {
        <span class="title-hash">{{ event.titleHash }}</span>
      }
      <h2 clas="event-title" [innerHTML]="event.title"></h2>
      @if (event.startDate && event.endDate) {
        <time class="event-date" [attr.start]="event.startDate" [attr.end]="event.endDate">
          {{ event.startDate | timePeriod: event.endDate : event.timezoneOffset }}
        </time>
      }
      @if (
        event.deadline &&
        (event.attendanceStatus === attendance_status.PENDING || event.attendanceStatus === attendance_status.OPEN)
      ) {
        <div>
          <em>{{
            'EVENT_RIBBON_CARD_EMBARGO_UNTIL' | translate: { date: event.deadline | localizedDate: 'longDate' }
          }}</em>
        </div>
      }
    </section>
    <footer>
      @if (event.location) {
        <div class="location" [innerHTML]="event.location"></div>
      }
      @if (index && total) {
        <div class="pages">{{ index }} / {{ total }}</div>
      }
    </footer>
  }
  <ng-template #tpl>
    @if (event.image) {
      <mb-media [media]="event.image"></mb-media>
    }
    @if (event.state === eventStates.UPCOMING) {
      <header>
        <mb-small-spinner></mb-small-spinner>
        @if (distance) {
          <span>
            {{ 'EVENT_CARD_STARTS_IN' | translate: { distance: distance } }}
          </span>
        }
      </header>
    }
    @if (event.state === eventStates.RUNNING) {
      <header>
        <mb-live-indicator></mb-live-indicator>
        {{ 'EVENT_CARD_RUNNING' | translate }}
      </header>
    }
    @if (event.attendanceStatus) {
      <span
        class="event-card-icon mb-icon mb-icon-event-{{ attendanceIcons[event.attendanceStatus] }}"
        [class.below-archived-tag]="isArchived"
      >
      </span>
    }
    <section>
      @if (event.titleHash) {
        <span class="title-hash">{{ event.titleHash }}</span>
      }
      <h2 clas="event-title" [innerHTML]="event.title"></h2>
      @if (event.startDate && event.endDate) {
        <time class="event-date" [attr.start]="event.startDate" [attr.end]="event.endDate">
          {{ event.startDate | timePeriod: event.endDate : event.timezoneOffset }}
        </time>
      }
      @if (
        event.deadline &&
        (event.attendanceStatus === attendance_status.PENDING || event.attendanceStatus === attendance_status.OPEN)
      ) {
        <div>
          <em>{{
            'EVENT_RIBBON_CARD_EMBARGO_UNTIL' | translate: { date: event.deadline | localizedDate: 'longDate' }
          }}</em>
        </div>
      }
    </section>
    <footer>
      @if (event.location) {
        <div class="location" [innerHTML]="event.location"></div>
      }
      @if (index && total) {
        <div class="pages">{{ index }} / {{ total }}</div>
      }
    </footer>
  </ng-template>
}
